import React, { useState } from 'react';
import CommonModal from '../common/CommonModal';
import InputBlock from '../common/InputBlock';
import DatePicker from '../common/DatePicker';
import { handleAddDemand } from '../../containers/APIFunctions';
import moment from 'moment';
import UtilService from '../../services/util';
import OpenNotification from '../../components/common/CommonButton/OpenNotification';
import { LOCAL_STORAGE_VAR, KYC_STATUS } from '../../constants/Common';
import { isEmpty } from 'util/utils';

const AddDemandPopup = (props) => {
  const [demandTitle, setDemandTitle] = useState('');
  const [expiryDate, setExpiryDate] = useState(moment().add(5, 'days').toISOString());

  const userData = UtilService.getLocalStorageItem(`${LOCAL_STORAGE_VAR}-user`);
  const message = isEmpty(userData)
    ? 'Register yourself to access the functionality.'
    : userData?.type !== 1 || userData?.type !== 11 || userData?.type !== 2 || userData?.type !== 8
    ? 'Please complete your KYC procedure to access the functionality.'
    : userData?.account?.isApproved === KYC_STATUS.PENDING
    ? 'Please wait to access the functionality untill your KYC documents get verify.'
    : userData?.account?.isApproved === KYC_STATUS.REJECT
    ? 'Your KYC is rejected. Please upload your KYC again with right information'
    : userData?.account?.isApproved === KYC_STATUS.APPROVED
    ? 'Functionality is disabled for sometime.'
    : undefined;

  return (
    <>
      <CommonModal
        visible={props.showDemand}
        handleOk={() => {
          if (props.permission && props.permission.insert) {
            handleAddDemand(props.selectedMaster, demandTitle, expiryDate, (success) => {
              if (success) {
                props.handleReverseState('showDemand');
                props.handleRefresh();
              }
            });
          } else {
            OpenNotification({
              type: 'error',
              title: message,
            });
          }
        }}
        handleCancel={() => props.handleReverseState('showDemand')}
        title="Add Demand"
        footerShow
        submitTitle="Submit"
        cancelTitle="Cancel"
      >
        <div className="searchPopupCommon">
          <div className="searchPopupTwoValue">
            <InputBlock
              label="Demand Title"
              placeholder="Demand Title"
              value={demandTitle}
              onChange={(e) => setDemandTitle(e.target.value)}
            />
            <DatePicker
              label="Expire Date"
              single
              expiryDate={expiryDate}
              handleChange={(dt) => setExpiryDate(dt ? dt.toISOString() : moment().add(5, 'days').toISOString())}
              disabledDate={(current) => {
                return current && current <= moment().startOf('day');
              }}
            />
          </div>
        </div>
      </CommonModal>
    </>
  );
};

export default AddDemandPopup;
